import { service } from '../index.js'

// 购物车管理
export const cart = {
  // 列表
  list: ({ params = {} } = {}) => {
    return service.get('/cart/list', params)
  },
  
  // 管理员列表（包含用户信息）
  listAdmin: ({ params = {} } = {}) => {
    return service.get('/cart/list-all', params)
  },
  
  // 添加
  add: (data) => {
    return service.post('/cart/add', data)
  },
  
  // 更新数量
  update: (data) => {
    return service.post('/cart/update', data)
  },
  
  // 删除
  delete: (params) => {
    return service.post('/cart/remove', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/cart.js